type IconLinkedinProps = {
    className?: string;
};

export function IconLinkedin(props: IconLinkedinProps) {
    const { className = '' } = props;
    return (
        <svg
            aria-hidden={true}
            className={`${className}`}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 0.703125H5C2.239 0.703125 0 2.94213 0 5.70312V19.7031C0 22.4641 2.239 24.7031 5 24.7031H19C21.762 24.7031 24 22.4641 24 19.7031V5.70312C24 2.94213 21.762 0.703125 19 0.703125ZM8 19.7031H5V8.70312H8V19.7031ZM6.5 7.43513C5.534 7.43513 4.75 6.64512 4.75 5.67112C4.75 4.69712 5.534 3.90712 6.5 3.90712C7.466 3.90712 8.25 4.69712 8.25 5.67112C8.25 6.64512 7.467 7.43513 6.5 7.43513ZM20 19.7031H17V14.0991C17 10.7311 13 10.9861 13 14.0991V19.7031H10V8.70312H13V10.4681C14.396 7.88212 20 7.69113 20 12.9441V19.7031Z"
                fill={'black'}
            />
        </svg>
    );
}

export default IconLinkedin;
